var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51038 2.29167H8.13538M6.30204 1.375V3.20833M6.30204 2.29167H1.26038M3.09371 5.5H1.26038M4.92704 4.58333V6.41667M9.96871 5.5H4.92704M9.51038 8.70833H8.13538M6.30204 7.79167V9.625M6.30204 8.70833H1.26038",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameters);
export default __webpack_public_path__ + "static/media/parameters.1e9461c4019be3f53ef54a543a2cf9fb.svg";
export { ForwardRef as ReactComponent };